import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";
import AnimatedCursor from "react-animated-cursor";
import Home from "./pages/Home";
import About from "./pages/About";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Vision from "./pages/Vision";
import NewsPage from "./pages/News";
import Projects from "./pages/Projects";
import ProjectDetalis from "./pages/ProjectDetails";
import CeoWord from "./pages/CeoWord";
import ContentUs from "./pages/ContactUs";
import EventDetails from "./pages/EventDetails";
import NewsDetails from "./pages/NewsDetails";
import ScrollTop from "./components/shared/ScrollTop";
import '../src/configs/i18n';
function App() {
    return (
        <div className="App">
            <Router>
                <ScrollTop />
              
                <Routes>
                    <Route index element={<Home />} />
                    <Route path={"about-us"} element={<About />} />
                    <Route path={"vision"} element={<Vision />} />
                    <Route path={"ceo-message"} element={<CeoWord />} />
                    <Route path={"contact-us"} element={<ContentUs />} />
                    <Route path={"projects"} element={<Projects />} />
                    <Route path={"news"} element={<NewsPage />} />
                    <Route path={"news/:id"} element={<NewsDetails />} />
                    <Route path="/projects/:id" element={<ProjectDetalis />} />
                    <Route path="/:event" element={<EventDetails />} />
                </Routes>
                <AnimatedCursor
                    innerStyle={{ background: "rgba(30, 144, 255,0.7)" }}
                    outerStyle={{
                        background: "transparent",
                        border: "1px solid rgb(30, 144, 255)",
                    }}
                    innerSize={8}
                    outerSize={25}
                    color="30, 144, 255"
                    outerAlpha={0.2}
                    innerScale={1.8}
                    outerScale={1.2}
                    clickables={[
                        "a",
                        'input[type="text"]',
                        'input[type="email"]',
                        'input[type="number"]',
                        'input[type="submit"]',
                        'input[type="image"]',
                        "label[for]",
                        "select",
                        "textarea",
                        "button",
                        ".link",
                        ".cursor-pointer",
                    ]}
                />
            </Router>
        </div>
    );
}

export default App;
